import {
  ADD_MESSAGE,
  CLEAR_MESSAGES,
  CLEAR_MESSAGES_BY_SOURCE,
} from "./actions";

const _initialMessagesState = {
  messages: [],
  count: 0,
};

function messagesReducer(state = _initialMessagesState, action) {
  const { count, messages } = state;

  switch (action.type) {
    case ADD_MESSAGE:
      return {
        ...state,
        messages: [...messages, action.payload],
        count: count + 1,
      };
    case CLEAR_MESSAGES:
      return {
        ...state,
        messages: [],
        count: 0,
      };
    case CLEAR_MESSAGES_BY_SOURCE: {
      const filtered = messages.filter(
        (m) => m.source !== action.payload.source,
      );

      return {
        ...state,
        messages: filtered,
        count: filtered.length,
      };
    }
    default:
      return state;
  }
}

export { messagesReducer, _initialMessagesState };
